import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import Table from "../../elements/Table";

import Logo1 from "../../assets/logos/1.png";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function ClientsBPDev() {
  const classes = useStyles();

  useEffect(() => {
    // console.log
  }, []);

  const columns = [
    {
      title: "Alias",
      field: "alias",
    },
    {
      title: "Name",
      field: "name",
    },
    {
      title: "Address",
      field: "address",
    },
    { title: "Contact Person", field: "contact_person" },
    { title: "Role", field: "role" },
    { title: "Phone", field: "phone" },
    { title: "Email", field: "email" },
    { title: "Payment Amount", field: "payment_amount" },
    { title: "Payment Frequency", field: "payment_frequency" },
    { title: "Next Payment Due", field: "next_payment_due" },
    { title: "Credit", field: "credit" },
    { title: "Outstanding", field: "outstanding" },
  ];

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Table
        title={
          <>
            <img src={Logo1} style={{ width: 40, marginTop: "20px" }} alt="" />
            <p style={{ fontSize: "20px" }}>BPDev Clients</p>
          </>
        }
        columns={columns}
        api="/api/clients-dev"
        actionsColumnIndex={0}
      />
    </Container>
  );
}
